import { render, staticRenderFns } from "./ScreenFullMode.vue?vue&type=template&id=204e790f&scoped=true&lang=pug&"
import script from "./ScreenFullMode.vue?vue&type=script&lang=js&"
export * from "./ScreenFullMode.vue?vue&type=script&lang=js&"
import style0 from "./ScreenFullMode.vue?vue&type=style&index=0&id=204e790f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e790f",
  null
  
)

export default component.exports